module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Laundry Town")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#prologue"
    }
  }, [_vm._v("Prologue")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-one-magees-trip"
    }
  }, [_vm._v("Chapter One: Magee’s Trip")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-two-dazzled-by-events"
    }
  }, [_vm._v("Chapter Two: Dazzled by Events")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-three-recollections"
    }
  }, [_vm._v("Chapter Three: Recollections")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-four-the-outside",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: The Outside")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-five-rope-people-in-charge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Rope People in Charge")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-six-pee-monkeys-everywhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Pee Monkeys Everywhere")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-seven-magee-sees-wonders-in-an-unknown-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Magee Sees Wonders in an Unknown World")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-eight-razor-and-stick-thin-come-to-the-rescue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Razor and Stick-Thin Come to the Rescue")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-nine-meeting-the-crew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Meeting the Crew")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-ten-preparing-for-take-off",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Preparing for Take-Off")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-eleven-the-take-off",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Take-Off")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-twelve-an-ominous-ship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: An Ominous Ship")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-thirteen-the-trip-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: The Trip Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fourteen-magic-wins-the-battle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Magic Wins the Battle")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-fifteen-radiants-true-colours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Radiant’s True Colours")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-sixteen-brothers-at-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: Brothers at War")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-seventeen-next-stop-japan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: Next Stop Japan")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-eighteen-the-return-to-laundry-town",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: The Return to Laundry Town")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0